// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { pagedRequestOptionsFromJson, pagedRequestOptionsToJson, pagedResponseMetadataFromJson, pagedResponseMetadataToJson } from '../../vendastatypes/codec';
export function registerResponseToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function registerResponseFromJson(o) {
    var _a, _b;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function resendVerificationEmailRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.recaptcha !== undefined)
        o['recaptcha'] = m.recaptcha;
    return o;
}
export function resendVerificationEmailRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        recaptcha: (_c = o['recaptcha']) !== null && _c !== void 0 ? _c : '',
    };
}
export function deleteFileRequestToJson(m) {
    const o = {};
    if (m.fileId !== undefined)
        o['fileId'] = m.fileId;
    return o;
}
export function deleteFileRequestFromJson(o) {
    var _a;
    return {
        fileId: (_a = o['fileId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function provisionBusinessRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function provisionBusinessRequestFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function addressToJson(m) {
    const o = {};
    if (m.address !== undefined)
        o['address'] = m.address;
    if (m.city !== undefined)
        o['city'] = m.city;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.country !== undefined)
        o['country'] = m.country;
    if (m.postalCode !== undefined)
        o['postalCode'] = m.postalCode;
    return o;
}
export function addressFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        address: (_a = o['address']) !== null && _a !== void 0 ? _a : '',
        city: (_b = o['city']) !== null && _b !== void 0 ? _b : '',
        state: (_c = o['state']) !== null && _c !== void 0 ? _c : '',
        country: (_d = o['country']) !== null && _d !== void 0 ? _d : '',
        postalCode: (_e = o['postalCode']) !== null && _e !== void 0 ? _e : '',
    };
}
export function businessDataToJson(m) {
    const o = {};
    if (m.address !== undefined)
        o['address'] = addressToJson(m.address);
    if (m.businessCategory !== undefined)
        o['businessCategory'] = m.businessCategory;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.websiteUrl !== undefined)
        o['websiteUrl'] = m.websiteUrl;
    if (m.facebookUrl !== undefined)
        o['facebookUrl'] = m.facebookUrl;
    if (m.twitterUrl !== undefined)
        o['twitterUrl'] = m.twitterUrl;
    return o;
}
export function businessDataFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        address: o['address'] ? addressFromJson(o['address']) : undefined,
        businessCategory: (_a = o['businessCategory']) !== null && _a !== void 0 ? _a : '',
        phoneNumber: (_b = o['phoneNumber']) !== null && _b !== void 0 ? _b : '',
        websiteUrl: (_c = o['websiteUrl']) !== null && _c !== void 0 ? _c : '',
        facebookUrl: (_d = o['facebookUrl']) !== null && _d !== void 0 ? _d : '',
        twitterUrl: (_e = o['twitterUrl']) !== null && _e !== void 0 ? _e : '',
    };
}
export function contactToJson(m) {
    const o = {};
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    return o;
}
export function contactFromJson(o) {
    var _a, _b;
    return {
        firstName: (_a = o['firstName']) !== null && _a !== void 0 ? _a : '',
        lastName: (_b = o['lastName']) !== null && _b !== void 0 ? _b : '',
    };
}
export function utmDataToJson(m) {
    const o = {};
    if (m.utmCampaign !== undefined)
        o['utmCampaign'] = m.utmCampaign;
    if (m.utmMedium !== undefined)
        o['utmMedium'] = m.utmMedium;
    if (m.utmSource !== undefined)
        o['utmSource'] = m.utmSource;
    if (m.utmContent !== undefined)
        o['utmContent'] = m.utmContent;
    if (m.utmTerm !== undefined)
        o['utmTerm'] = m.utmTerm;
    if (m.gclid !== undefined)
        o['gclid'] = m.gclid;
    if (m.fbclid !== undefined)
        o['fbclid'] = m.fbclid;
    if (m.msclkid !== undefined)
        o['msclkid'] = m.msclkid;
    return o;
}
export function utmDataFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        utmCampaign: (_a = o['utmCampaign']) !== null && _a !== void 0 ? _a : '',
        utmMedium: (_b = o['utmMedium']) !== null && _b !== void 0 ? _b : '',
        utmSource: (_c = o['utmSource']) !== null && _c !== void 0 ? _c : '',
        utmContent: (_d = o['utmContent']) !== null && _d !== void 0 ? _d : '',
        utmTerm: (_e = o['utmTerm']) !== null && _e !== void 0 ? _e : '',
        gclid: (_f = o['gclid']) !== null && _f !== void 0 ? _f : '',
        fbclid: (_g = o['fbclid']) !== null && _g !== void 0 ? _g : '',
        msclkid: (_h = o['msclkid']) !== null && _h !== void 0 ? _h : '',
    };
}
export function registerRequestToJson(m) {
    const o = {};
    if (m.businessData !== undefined)
        o['businessData'] = businessDataToJson(m.businessData);
    if (m.contact !== undefined)
        o['contact'] = contactToJson(m.contact);
    if (m.businessName !== undefined)
        o['businessName'] = m.businessName;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.placeId !== undefined)
        o['placeId'] = m.placeId;
    if (m.salesPersonId !== undefined)
        o['salesPersonId'] = m.salesPersonId;
    if (m.recaptcha !== undefined)
        o['recaptcha'] = m.recaptcha;
    if (m.password !== undefined)
        o['password'] = m.password;
    if (m.utmData !== undefined)
        o['utmData'] = utmDataToJson(m.utmData);
    return o;
}
export function registerRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        businessData: o['businessData'] ? businessDataFromJson(o['businessData']) : undefined,
        contact: o['contact'] ? contactFromJson(o['contact']) : undefined,
        businessName: (_a = o['businessName']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        marketId: (_c = o['marketId']) !== null && _c !== void 0 ? _c : '',
        email: (_d = o['email']) !== null && _d !== void 0 ? _d : '',
        placeId: (_e = o['placeId']) !== null && _e !== void 0 ? _e : '',
        salesPersonId: (_f = o['salesPersonId']) !== null && _f !== void 0 ? _f : '',
        recaptcha: (_g = o['recaptcha']) !== null && _g !== void 0 ? _g : '',
        password: (_h = o['password']) !== null && _h !== void 0 ? _h : '',
        utmData: o['utmData'] ? utmDataFromJson(o['utmData']) : undefined,
    };
}
export function deleteBusinessRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.deleteUser !== undefined)
        o['deleteUser'] = m.deleteUser;
    return o;
}
export function deleteBusinessRequestFromJson(o) {
    var _a, _b, _c;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        message: (_b = o['message']) !== null && _b !== void 0 ? _b : '',
        deleteUser: (_c = o['deleteUser']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getTrackerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function getTrackerRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function trackersToJson(m) {
    const o = {};
    if (m.welcomeVideo !== undefined)
        o['welcomeVideo'] = m.welcomeVideo;
    if (m.academy !== undefined)
        o['academy'] = m.academy;
    if (m.skippedGbpConnection !== undefined)
        o['skippedGbpConnection'] = m.skippedGbpConnection;
    if (m.skippedIntegrationConnection !== undefined)
        o['skippedIntegrationConnection'] = m.skippedIntegrationConnection;
    if (m.skippedWebchatSetup !== undefined)
        o['skippedWebchatSetup'] = m.skippedWebchatSetup;
    if (m.skippedSmsRegistration !== undefined)
        o['skippedSmsRegistration'] = m.skippedSmsRegistration;
    if (m.skippedMobileNotification !== undefined)
        o['skippedMobileNotification'] = m.skippedMobileNotification;
    if (m.skippedAiWorkforce !== undefined)
        o['skippedAiWorkforce'] = m.skippedAiWorkforce;
    if (m.skippedBecomeReseller !== undefined)
        o['skippedBecomeReseller'] = m.skippedBecomeReseller;
    return o;
}
export function trackersFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        welcomeVideo: (_a = o['welcomeVideo']) !== null && _a !== void 0 ? _a : false,
        academy: (_b = o['academy']) !== null && _b !== void 0 ? _b : false,
        skippedGbpConnection: (_c = o['skippedGbpConnection']) !== null && _c !== void 0 ? _c : false,
        skippedIntegrationConnection: (_d = o['skippedIntegrationConnection']) !== null && _d !== void 0 ? _d : false,
        skippedWebchatSetup: (_e = o['skippedWebchatSetup']) !== null && _e !== void 0 ? _e : false,
        skippedSmsRegistration: (_f = o['skippedSmsRegistration']) !== null && _f !== void 0 ? _f : false,
        skippedMobileNotification: (_g = o['skippedMobileNotification']) !== null && _g !== void 0 ? _g : false,
        skippedAiWorkforce: (_h = o['skippedAiWorkforce']) !== null && _h !== void 0 ? _h : false,
        skippedBecomeReseller: (_j = o['skippedBecomeReseller']) !== null && _j !== void 0 ? _j : false,
    };
}
export function getTrackerResponseToJson(m) {
    const o = {};
    if (m.trackers !== undefined)
        o['trackers'] = trackersToJson(m.trackers);
    return o;
}
export function getTrackerResponseFromJson(o) {
    return {
        trackers: o['trackers'] ? trackersFromJson(o['trackers']) : undefined,
    };
}
export function setTrackerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.tracker !== undefined)
        o['tracker'] = m.tracker;
    return o;
}
export function setTrackerRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        tracker: (_c = o['tracker']) !== null && _c !== void 0 ? _c : '',
    };
}
export function setTrackerResponseToJson(m) {
    const o = {};
    if (m.success !== undefined)
        o['success'] = m.success;
    return o;
}
export function setTrackerResponseFromJson(o) {
    var _a;
    return {
        success: (_a = o['success']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getCreatePasswordUrlRequestToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getCreatePasswordUrlRequestFromJson(o) {
    var _a, _b;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getCreatePasswordUrlResponseToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    return o;
}
export function getCreatePasswordUrlResponseFromJson(o) {
    var _a;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendWelcomeEmailRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.loginUrl !== undefined)
        o['loginUrl'] = m.loginUrl;
    if (m.usePlatformDefaultDomain !== undefined)
        o['usePlatformDefaultDomain'] = m.usePlatformDefaultDomain;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.welcomeMessage !== undefined)
        o['welcomeMessage'] = m.welcomeMessage;
    if (m.languageCode !== undefined)
        o['languageCode'] = m.languageCode;
    return o;
}
export function sendWelcomeEmailRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        loginUrl: (_c = o['loginUrl']) !== null && _c !== void 0 ? _c : '',
        usePlatformDefaultDomain: (_d = o['usePlatformDefaultDomain']) !== null && _d !== void 0 ? _d : false,
        marketId: (_e = o['marketId']) !== null && _e !== void 0 ? _e : '',
        welcomeMessage: (_f = o['welcomeMessage']) !== null && _f !== void 0 ? _f : '',
        languageCode: (_g = o['languageCode']) !== null && _g !== void 0 ? _g : '',
    };
}
export function getWelcomeEmailTemplateRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userName !== undefined)
        o['userName'] = m.userName;
    if (m.loginUrl !== undefined)
        o['loginUrl'] = m.loginUrl;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.welcomeMessage !== undefined)
        o['welcomeMessage'] = m.welcomeMessage;
    if (m.languageCode !== undefined)
        o['languageCode'] = m.languageCode;
    return o;
}
export function getWelcomeEmailTemplateRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userName: (_b = o['userName']) !== null && _b !== void 0 ? _b : '',
        loginUrl: (_c = o['loginUrl']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        welcomeMessage: (_e = o['welcomeMessage']) !== null && _e !== void 0 ? _e : '',
        languageCode: (_f = o['languageCode']) !== null && _f !== void 0 ? _f : '',
    };
}
export function getWelcomeEmailTemplateResponseToJson(m) {
    const o = {};
    if (m.templateHtml !== undefined)
        o['templateHtml'] = m.templateHtml;
    return o;
}
export function getWelcomeEmailTemplateResponseFromJson(o) {
    var _a;
    return {
        templateHtml: (_a = o['templateHtml']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendOnboardingEmailRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.languageCode !== undefined)
        o['languageCode'] = m.languageCode;
    if (m.customEmailIntro !== undefined)
        o['customEmailIntro'] = m.customEmailIntro;
    if (m.waitForProvisioning !== undefined)
        o['waitForProvisioning'] = m.waitForProvisioning;
    return o;
}
export function sendOnboardingEmailRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        accountGroupId: (_c = o['accountGroupId']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        languageCode: (_e = o['languageCode']) !== null && _e !== void 0 ? _e : '',
        customEmailIntro: (_f = o['customEmailIntro']) !== null && _f !== void 0 ? _f : '',
        waitForProvisioning: (_g = o['waitForProvisioning']) !== null && _g !== void 0 ? _g : false,
    };
}
export function startOnboardingRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.userIds !== undefined) {
        o['userIds'] = m.userIds.map(e => e);
    }
    if (m.expectedAppIds !== undefined) {
        o['expectedAppIds'] = m.expectedAppIds.map(e => e);
    }
    if (m.customEmailIntro !== undefined)
        o['customEmailIntro'] = m.customEmailIntro;
    return o;
}
export function startOnboardingRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        marketId: (_c = o['marketId']) !== null && _c !== void 0 ? _c : '',
        userIds: ((_d = o['userIds']) !== null && _d !== void 0 ? _d : []).map(e => e),
        expectedAppIds: ((_e = o['expectedAppIds']) !== null && _e !== void 0 ? _e : []).map(e => e),
        customEmailIntro: (_f = o['customEmailIntro']) !== null && _f !== void 0 ? _f : '',
    };
}
export function rejectedRecipientToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    return o;
}
export function rejectedRecipientFromJson(o) {
    var _a, _b;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
    };
}
export function startOnboardingResponseToJson(m) {
    const o = {};
    if (m.rejectedRecipients !== undefined) {
        o['rejectedRecipients'] = m.rejectedRecipients.map(e => rejectedRecipientToJson(e));
    }
    return o;
}
export function startOnboardingResponseFromJson(o) {
    var _a;
    return {
        rejectedRecipients: ((_a = o['rejectedRecipients']) !== null && _a !== void 0 ? _a : []).map(e => rejectedRecipientFromJson(e)),
    };
}
export function getOnboardingEmailTemplateRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.languageCode !== undefined)
        o['languageCode'] = m.languageCode;
    if (m.customEmailIntro !== undefined)
        o['customEmailIntro'] = m.customEmailIntro;
    return o;
}
export function getOnboardingEmailTemplateRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        marketId: (_c = o['marketId']) !== null && _c !== void 0 ? _c : '',
        languageCode: (_d = o['languageCode']) !== null && _d !== void 0 ? _d : '',
        customEmailIntro: (_e = o['customEmailIntro']) !== null && _e !== void 0 ? _e : '',
    };
}
export function getOnboardingEmailTemplateResponseToJson(m) {
    const o = {};
    if (m.templateHtml !== undefined)
        o['templateHtml'] = m.templateHtml;
    if (m.subject !== undefined)
        o['subject'] = m.subject;
    return o;
}
export function getOnboardingEmailTemplateResponseFromJson(o) {
    var _a, _b;
    return {
        templateHtml: (_a = o['templateHtml']) !== null && _a !== void 0 ? _a : '',
        subject: (_b = o['subject']) !== null && _b !== void 0 ? _b : '',
    };
}
export function createAndAssociateRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.password !== undefined)
        o['password'] = m.password;
    if (m.confirmPassword !== undefined)
        o['confirmPassword'] = m.confirmPassword;
    if (m.phone !== undefined)
        o['phone'] = m.phone;
    if (m.greetingName !== undefined)
        o['greetingName'] = m.greetingName;
    if (m.sendWelcomeEmail !== undefined)
        o['sendWelcomeEmail'] = m.sendWelcomeEmail;
    if (m.welcomeMessage !== undefined)
        o['welcomeMessage'] = m.welcomeMessage;
    if (m.failOnExistingUser !== undefined)
        o['failOnExistingUser'] = m.failOnExistingUser;
    if (m.notificationsFlag !== undefined)
        o['notificationsFlag'] = m.notificationsFlag;
    if (m.failOnExistingAssociation !== undefined)
        o['failOnExistingAssociation'] = m.failOnExistingAssociation;
    if (m.languageCode !== undefined)
        o['languageCode'] = m.languageCode;
    return o;
}
export function createAndAssociateRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        accountGroupId: (_c = o['accountGroupId']) !== null && _c !== void 0 ? _c : '',
        firstName: (_d = o['firstName']) !== null && _d !== void 0 ? _d : '',
        lastName: (_e = o['lastName']) !== null && _e !== void 0 ? _e : '',
        password: (_f = o['password']) !== null && _f !== void 0 ? _f : '',
        confirmPassword: (_g = o['confirmPassword']) !== null && _g !== void 0 ? _g : '',
        phone: (_h = o['phone']) !== null && _h !== void 0 ? _h : '',
        greetingName: (_j = o['greetingName']) !== null && _j !== void 0 ? _j : '',
        sendWelcomeEmail: (_k = o['sendWelcomeEmail']) !== null && _k !== void 0 ? _k : false,
        welcomeMessage: (_l = o['welcomeMessage']) !== null && _l !== void 0 ? _l : '',
        failOnExistingUser: (_m = o['failOnExistingUser']) !== null && _m !== void 0 ? _m : false,
        notificationsFlag: (_o = o['notificationsFlag']) !== null && _o !== void 0 ? _o : false,
        failOnExistingAssociation: (_p = o['failOnExistingAssociation']) !== null && _p !== void 0 ? _p : false,
        languageCode: (_q = o['languageCode']) !== null && _q !== void 0 ? _q : '',
    };
}
export function createAndAssociateResponseToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.unifiedUserId !== undefined)
        o['unifiedUserId'] = m.unifiedUserId;
    return o;
}
export function createAndAssociateResponseFromJson(o) {
    var _a, _b;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
        unifiedUserId: (_b = o['unifiedUserId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listUsersForBusinessRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function listUsersForBusinessRequestFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function removeUserFromBusinessRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function removeUserFromBusinessRequestFromJson(o) {
    var _a, _b;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function associatedUserToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.phone !== undefined)
        o['phone'] = m.phone;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.profileImageUrl !== undefined)
        o['profileImageUrl'] = m.profileImageUrl;
    return o;
}
export function associatedUserFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        firstName: (_b = o['firstName']) !== null && _b !== void 0 ? _b : '',
        lastName: (_c = o['lastName']) !== null && _c !== void 0 ? _c : '',
        phone: (_d = o['phone']) !== null && _d !== void 0 ? _d : '',
        userId: (_e = o['userId']) !== null && _e !== void 0 ? _e : '',
        profileImageUrl: (_f = o['profileImageUrl']) !== null && _f !== void 0 ? _f : '',
    };
}
export function listUsersForBusinessResponseToJson(m) {
    const o = {};
    if (m.associatedUsers !== undefined) {
        o['associatedUsers'] = m.associatedUsers.map(e => associatedUserToJson(e));
    }
    return o;
}
export function listUsersForBusinessResponseFromJson(o) {
    var _a;
    return {
        associatedUsers: ((_a = o['associatedUsers']) !== null && _a !== void 0 ? _a : []).map(e => associatedUserFromJson(e)),
    };
}
export function listUsersForBusinessV2RequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listUsersForBusinessV2RequestFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listUsersForBusinessV2ResponseToJson(m) {
    const o = {};
    if (m.associatedUsers !== undefined) {
        o['associatedUsers'] = m.associatedUsers.map(e => associatedUserToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listUsersForBusinessV2ResponseFromJson(o) {
    var _a;
    return {
        associatedUsers: ((_a = o['associatedUsers']) !== null && _a !== void 0 ? _a : []).map(e => associatedUserFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function listUsersForBusinessesRequestToJson(m) {
    const o = {};
    if (m.accountGroupIds !== undefined) {
        o['accountGroupIds'] = m.accountGroupIds.map(e => e);
    }
    if (m.multiLocationPath !== undefined)
        o['multiLocationPath'] = m.multiLocationPath;
    return o;
}
export function listUsersForBusinessesRequestFromJson(o) {
    var _a, _b;
    return {
        accountGroupIds: ((_a = o['accountGroupIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        multiLocationPath: (_b = o['multiLocationPath']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listUsersForBusinessesResponseToJson(m) {
    const o = {};
    if (m.associatedUsers !== undefined) {
        o['associatedUsers'] = m.associatedUsers.map(e => associatedUserToJson(e));
    }
    return o;
}
export function listUsersForBusinessesResponseFromJson(o) {
    var _a;
    return {
        associatedUsers: ((_a = o['associatedUsers']) !== null && _a !== void 0 ? _a : []).map(e => associatedUserFromJson(e)),
    };
}
export function getConnectionsRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function getConnectionsRequestFromJson(o) {
    var _a;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function repeatedConnectionToJson(m) {
    const o = {};
    if (m.connection !== undefined) {
        o['connection'] = m.connection.map(e => connectionToJson(e));
    }
    return o;
}
export function repeatedConnectionFromJson(o) {
    var _a;
    return {
        connection: ((_a = o['connection']) !== null && _a !== void 0 ? _a : []).map(e => connectionFromJson(e)),
    };
}
export function connectionToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.clientTags !== undefined) {
        o['clientTags'] = m.clientTags.map(e => e);
    }
    if (m.isVerified !== undefined)
        o['isVerified'] = m.isVerified;
    if (m.pages !== undefined) {
        o['pages'] = m.pages.map(e => connectionToJson(e));
    }
    if (m.ssid !== undefined)
        o['ssid'] = m.ssid;
    if (m.tokenIsBroken !== undefined)
        o['tokenIsBroken'] = m.tokenIsBroken;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.locationId !== undefined)
        o['locationId'] = m.locationId;
    if (m.mapsUri !== undefined)
        o['mapsUri'] = m.mapsUri;
    if (m.deleteUrl !== undefined)
        o['deleteUrl'] = m.deleteUrl;
    return o;
}
export function connectionFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        clientTags: ((_b = o['clientTags']) !== null && _b !== void 0 ? _b : []).map(e => e),
        isVerified: (_c = o['isVerified']) !== null && _c !== void 0 ? _c : false,
        pages: ((_d = o['pages']) !== null && _d !== void 0 ? _d : []).map(e => connectionFromJson(e)),
        ssid: (_e = o['ssid']) !== null && _e !== void 0 ? _e : '',
        tokenIsBroken: (_f = o['tokenIsBroken']) !== null && _f !== void 0 ? _f : false,
        type: (_g = o['type']) !== null && _g !== void 0 ? _g : '',
        locationId: (_h = o['locationId']) !== null && _h !== void 0 ? _h : '',
        mapsUri: (_j = o['mapsUri']) !== null && _j !== void 0 ? _j : '',
        deleteUrl: (_k = o['deleteUrl']) !== null && _k !== void 0 ? _k : '',
    };
}
export function getConnectionsResponseToJson(m) {
    const o = {};
    if (m.connections !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.connections)) {
            map[k] = repeatedConnectionToJson(v);
        }
        o['connections'] = map;
    }
    return o;
}
export function getConnectionsResponseFromJson(o) {
    return {
        connections: o['connections']
            ? Object.fromEntries(Object.entries(o['connections']).map(([k, v]) => [k, repeatedConnectionFromJson(v)]))
            : {},
    };
}
export function connectionInfoToJson(m) {
    const o = {};
    if (m.facebook !== undefined)
        o['facebook'] = m.facebook;
    if (m.instagram !== undefined)
        o['instagram'] = m.instagram;
    if (m.linkedin !== undefined)
        o['linkedin'] = m.linkedin;
    if (m.twitter !== undefined)
        o['twitter'] = m.twitter;
    return o;
}
export function connectionInfoFromJson(o) {
    var _a, _b, _c, _d;
    return {
        facebook: (_a = o['facebook']) !== null && _a !== void 0 ? _a : false,
        instagram: (_b = o['instagram']) !== null && _b !== void 0 ? _b : false,
        linkedin: (_c = o['linkedin']) !== null && _c !== void 0 ? _c : false,
        twitter: (_d = o['twitter']) !== null && _d !== void 0 ? _d : false,
    };
}
export function getConnectionsInfoRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function getConnectionsInfoRequestFromJson(o) {
    var _a;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getConnectionsInfoResponseToJson(m) {
    const o = {};
    if (m.connectionInfo !== undefined)
        o['connectionInfo'] = connectionInfoToJson(m.connectionInfo);
    return o;
}
export function getConnectionsInfoResponseFromJson(o) {
    return {
        connectionInfo: o['connectionInfo'] ? connectionInfoFromJson(o['connectionInfo']) : undefined,
    };
}
export function getTwitterAppCheckerRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function getTwitterAppCheckerRequestFromJson(o) {
    var _a;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getTwitterAppCheckerResponseToJson(m) {
    const o = {};
    if (m.totalConnections !== undefined)
        o['totalConnections'] = m.totalConnections;
    if (m.reconnectGroup !== undefined) {
        o['reconnectGroup'] = m.reconnectGroup.map(e => reconnectGroupToJson(e));
    }
    return o;
}
export function getTwitterAppCheckerResponseFromJson(o) {
    var _a, _b;
    return {
        totalConnections: (_a = o['totalConnections']) !== null && _a !== void 0 ? _a : 0,
        reconnectGroup: ((_b = o['reconnectGroup']) !== null && _b !== void 0 ? _b : []).map(e => reconnectGroupFromJson(e)),
    };
}
export function reconnectGroupToJson(m) {
    const o = {};
    if (m.ssid !== undefined)
        o['ssid'] = m.ssid;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.tokenBroken !== undefined)
        o['tokenBroken'] = m.tokenBroken;
    return o;
}
export function reconnectGroupFromJson(o) {
    var _a, _b, _c;
    return {
        ssid: (_a = o['ssid']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        tokenBroken: (_c = o['tokenBroken']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getFacebookAppCheckerRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function getFacebookAppCheckerRequestFromJson(o) {
    var _a;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getFacebookAppCheckerResponseToJson(m) {
    const o = {};
    if (m.reconnectGroup !== undefined) {
        o['reconnectGroup'] = m.reconnectGroup.map(e => reconnectGroupToJson(e));
    }
    if (m.totalConnections !== undefined)
        o['totalConnections'] = m.totalConnections;
    if (m.reconnectNeeded !== undefined)
        o['reconnectNeeded'] = m.reconnectNeeded;
    return o;
}
export function getFacebookAppCheckerResponseFromJson(o) {
    var _a, _b, _c;
    return {
        reconnectGroup: ((_a = o['reconnectGroup']) !== null && _a !== void 0 ? _a : []).map(e => reconnectGroupFromJson(e)),
        totalConnections: (_b = o['totalConnections']) !== null && _b !== void 0 ? _b : 0,
        reconnectNeeded: (_c = o['reconnectNeeded']) !== null && _c !== void 0 ? _c : false,
    };
}
export function sendReviewRequestToContactsFiltersToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function sendReviewRequestToContactsFiltersFromJson(o) {
    var _a;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendReviewRequestToContactsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = sendReviewRequestToContactsFiltersToJson(m.filters);
    return o;
}
export function sendReviewRequestToContactsRequestFromJson(o) {
    return {
        filters: o['filters'] ? sendReviewRequestToContactsFiltersFromJson(o['filters']) : undefined,
    };
}
export function sendReviewRequestToContactsResponseToJson(m) {
    const o = {};
    return o;
}
export function sendReviewRequestToContactsResponseFromJson(o) {
    return {};
}
export function requestShortOTPCodeRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    return o;
}
export function requestShortOTPCodeRequestFromJson(o) {
    var _a;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
    };
}
export function requestShortOTPCodeResponseToJson(m) {
    const o = {};
    return o;
}
export function requestShortOTPCodeResponseFromJson(o) {
    return {};
}
export function namespaceDetailsToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.logoUrl !== undefined)
        o['logoUrl'] = m.logoUrl;
    return o;
}
export function namespaceDetailsFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        logoUrl: (_c = o['logoUrl']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listNamespaceDetailsRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.otpCode !== undefined)
        o['otpCode'] = m.otpCode;
    return o;
}
export function listNamespaceDetailsRequestFromJson(o) {
    var _a, _b;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        otpCode: (_b = o['otpCode']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listNamespaceDetailsResponseToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => namespaceDetailsToJson(e));
    }
    return o;
}
export function listNamespaceDetailsResponseFromJson(o) {
    var _a;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => namespaceDetailsFromJson(e)),
    };
}
